import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { paymentService } from '../services/payment.service';

export default function PaymentSuccess() {
  const location = useLocation();
  const [orderInfo, setOrderInfo] = useState<any>(null);

  useEffect(() => {
    const pendingOrder = localStorage.getItem('pendingOrder');
    let parsedOrder: any = null;
    if (pendingOrder) {
      try {
        parsedOrder = JSON.parse(pendingOrder);
        setOrderInfo(parsedOrder);
      } catch {
        parsedOrder = null;
      }
    }

    const orderId =
      paymentService.extractRedsysOrderIdFromReturn(location.search) ||
      parsedOrder?.redsys_order_id;

    if (orderId) {
      paymentService.enqueueRegistration(orderId);
    }
    localStorage.removeItem('pendingOrder');
  }, [location.search]);

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{backgroundImage: 'url(/background.jpg)', backgroundSize: 'cover', backgroundPosition: 'center', backgroundAttachment: 'fixed'}}>
      <div className="bg-white rounded-lg shadow-lg max-w-md w-full p-8 text-center animate-fade-in border border-gray-200">
        <div className="w-20 h-20 bg-[#F90000]/10 rounded-full flex items-center justify-center mx-auto mb-6 border-4 border-[#F90000]/20">
          <svg xmlns="http://www.w3.org/2000/svg" className="h-12 w-12 text-[#F90000]" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </div>
        
        <h1 className="text-3xl font-bold text-[#F90000] mb-3">¡Pago Completado!</h1>
        <p className="text-gray-600 mb-8 max-w-xs mx-auto">
          Tu pago ha sido procesado correctamente. Recibirás un correo electrónico con los detalles de tu compra.
        </p>
        
        {orderInfo && (
          <div className="bg-gray-50 p-6 rounded-lg mb-8 text-left border border-gray-200 shadow-sm">
            <h2 className="font-bold text-lg mb-4 border-b border-gray-200 pb-3 text-gray-800">
              {orderInfo.is_change ? 'Cambios realizados' : 'Resumen de tu compra'}
            </h2>
            
            <div className="space-y-3">
              {orderInfo.garment_name && (
                <div className="flex justify-between">
                  <span className="font-medium text-gray-700">Prenda:</span>
                  <span className="text-gray-900">{orderInfo.garment_name}</span>
                </div>
              )}
              
              {orderInfo.color_name && (
                <div className="flex justify-between">
                  <span className="font-medium text-gray-700">Color:</span>
                  <span className="text-gray-900">{orderInfo.color_name}</span>
                </div>
              )}
              
              {orderInfo.size_name && (
                <div className="flex justify-between">
                  <span className="font-medium text-gray-700">Talla:</span>
                  <span className="text-gray-900">{orderInfo.size_name}</span>
                </div>
              )}
            </div>
            
            <div className="mt-6 pt-4 border-t border-gray-200 space-y-2">
              {orderInfo.is_change && orderInfo.order_change ? (
                <>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Pedido anterior pagado:</span>
                    <span className="text-gray-900">{Number(orderInfo.order_change.net_paid_amount).toFixed(2)}€</span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-600">Nuevo pedido:</span>
                    <span className="text-gray-900">{Number(orderInfo.order_change.new_price).toFixed(2)}€</span>
                  </div>
                  {Number(orderInfo.total_discount) > 0 && (
                    <div className="flex justify-between text-sm text-green-600">
                      <span>Descuentos aplicados:</span>
                      <span>-{Number(orderInfo.total_discount).toFixed(2)}€</span>
                    </div>
                  )}
                  <div className="flex justify-between items-center pt-2 border-t border-gray-200">
                    <span className="font-bold text-gray-800">Importe pagado:</span>
                    <span className="font-bold text-xl text-[#F90000]">
                      {orderInfo.order_change.requires_payment
                        ? Math.abs(Number(orderInfo.order_change.price_difference)).toFixed(2)
                        : '0.00'}€
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex justify-between">
                    <span className="text-gray-700">Subtotal:</span>
                    <span className="text-gray-900">{Number(orderInfo.total_price).toFixed(2)}€</span>
                  </div>
                  
                  {Number(orderInfo.total_discount) > 0 && (
                    <div className="flex justify-between text-green-600">
                      <span>Descuentos aplicados:</span>
                      <span>-{Number(orderInfo.total_discount).toFixed(2)}€</span>
                    </div>
                  )}
                  
                  <div className="flex justify-between items-center pt-2 border-t border-gray-200">
                    <span className="font-bold text-gray-800">Total:</span>
                    <span className="font-bold text-xl text-[#F90000]">{Number(orderInfo.final_price || orderInfo.total_price).toFixed(2)}€</span>
                  </div>
                </>
              )}
            </div>
          </div>
        )}
        
        <Link 
          to="/"
          className="w-full px-4 py-3.5 bg-[#F90000] text-white rounded-md font-medium hover:bg-[#D80000] transition-colors flex items-center justify-center space-x-2"
        >
          <span>Volver al inicio</span>
          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
            <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010 1.414z" clipRule="evenodd" />
          </svg>
        </Link>
      </div>
    </div>
  );
}
